import { useEffect, useState } from "react";
import { History, Sparkles } from "lucide-react";
import { getStudentId } from "@/lib/api";
import { getStudyHistory } from "@/lib/studyApi";
import Navbar from "@/components/Navbar";

export default function StudyHistory() {
  const [sessions, setSessions] = useState(null);

  useEffect(() => {
    getStudyHistory(getStudentId()).then(({ data }) => setSessions(data)).catch(() => setSessions([]));
  }, []);

  return (
    <div className="min-h-screen bg-background" data-testid="study-history-page">
      <Navbar student={null} />
      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <h1 className="font-heading font-extrabold text-2xl flex items-center gap-2 mb-6"><History className="text-primary" size={22} /> My Combine Study Sessions</h1>
        {sessions === null && <p className="text-muted-foreground text-sm">Loading...</p>}
        {sessions?.length === 0 && <p className="text-muted-foreground text-sm" data-testid="study-history-empty">No sessions yet — start one from Home!</p>}
        <div className="space-y-3">
          {sessions?.map((s) => (
            <div key={s.session_code} className="bg-card border border-border rounded-2xl p-4" data-testid={`history-session-${s.session_code}`}>
              <div className="flex justify-between items-start">
                <div>
                  <p className="font-bold text-sm">{s.topic}</p>
                  <p className="text-xs text-muted-foreground">{s.subject} · {s.participant_count} participants · {s.status}</p>
                </div>
                <p className="text-sm font-heading font-bold text-primary flex items-center gap-1"><Sparkles size={13} /> {s.smart_points}</p>
              </div>
              {s.mastery_score > 0 && <p className="text-xs text-muted-foreground mt-2">Mastery: {Math.round(s.mastery_score)}% {s.duration_minutes ? `· ${s.duration_minutes} min` : ""}</p>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
